// extracted by mini-css-extract-plugin
export default {"container":"languages_container__yuaZ0","title":"languages_title__EMgPL","cardsContainer":"languages_cardsContainer__g15RG","visualizer":"languages_visualizer__s3Bxl"};